module.exports = __webpack_public_path__ + "3ba9be98cce01cd1ff9dab15cb785c7d.pdf";